import { v4 as uuidv4 } from 'uuid'
import { PositionedArrayManager } from '@opallabs/lambda'
import { multiSorter } from './helpers'

/* Maps through a given list of content and applies the given
 * positions. If the position is new we set the content to
 * update.
 */
export const setPositionsOnContent = (contentList, positions) =>
  contentList.map((c, idx) => ({
    ...c,
    position: positions[idx],
    shouldUpdate: c.position !== positions[idx],
    uuid: uuidv4(),
  }))

export const sortContentList = (list) => {
  const outputList = [...list]
  const sortBy = outputList.every((c) => c.position !== null)
    ? 'position'
    : 'id'
  outputList.sort(multiSorter([{ sortBy, order: 'ASC' }]))
  return outputList
}

/*
 * Takes a list of content and an index at which to inset
 * a new position. Returns an array of positions with the
 * new one.
 */
export const getPositionsWithNewContent = (originalContentList, index) => {
  const arrayManager = new PositionedArrayManager(originalContentList)
  const contentList = sortContentList(originalContentList)
  const positions = contentList.map((p) => p.position)
  const updatedPositions = arrayManager.insertAt(contentList, index)

  positions.splice(index, 0, updatedPositions[index])

  updatedPositions.forEach((position, i) => {
    if (position !== null) {
      positions[i] = updatedPositions[i]
    }
  })

  return positions
}

/*
 * Handles moving an item in a list to a new index.
 * Returns a list of positions as a result of moving
 * an item to the new index.
 */
export const rearrangePositions = (contentList, index) => {
  const arrayManager = new PositionedArrayManager(contentList)
  const updatedPositions = arrayManager.moveTo(contentList, index)
  const positions = contentList.map((p) => p.position)

  positions.splice(index, 1, updatedPositions[index])
  positions.sort((a, b) => a - b)
  return positions
}

/*
 * Adds content to an array of content at the desired index.
 */
export const addContentToList = (atIndex, content, contentList) => {
  let outputList = [...contentList]
  outputList = sortContentList(outputList)
  outputList.splice(atIndex, 0, content)

  const positions = getPositionsWithNewContent(contentList, atIndex)
  outputList = setPositionsOnContent(outputList, positions)

  outputList = sortContentList(outputList)
  outputList[atIndex].isSaving = true
  outputList[atIndex].shouldUpdate = true
  return outputList
}

/*
 * Responsible for moving a content item from one index to another.
 */
export const reorderContentInList = (contentList, fromIndex, toIndex) => {
  let outputList = [...contentList]
  outputList = sortContentList(outputList)
  outputList.splice(toIndex, 0, outputList.splice(fromIndex, 1)[0])

  const positions = rearrangePositions(outputList, toIndex)
  outputList = setPositionsOnContent(outputList, positions)

  outputList = sortContentList(outputList)
  outputList[toIndex].isSaving = true
  outputList[toIndex].shouldUpdate = true
  return outputList
}
